<template>
<div class="k-page-content">
	<el-tabs v-model="activeName" class="box-eltab">
		<el-tab-pane label="下载任务管理" name="first">
			<div class="k-page-common">
					<div class="k-common-header">
					<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
						<el-form :inline="true" :model="searchForm" size="mini">
							<!-- <el-form-item label="任务名称">
								<el-input v-model="searchForm.task_name" placeholder="请填写任务名称" clearable></el-input>
							</el-form-item> -->
							<el-form-item label="任务类型">
								<el-select v-model="searchForm.type" placeholder="请选择类型" clearable style="width: 100%;">
									<el-option label="项目列表-EXCEL" value="project"></el-option>
									<el-option label="客户列表-EXCEL" value="customer"></el-option>
									<el-option label="执行列表-EXCEL" value="execute"></el-option>
									<el-option label="执行对账列表-EXCEL" value="executeDuizhang"></el-option>
									<el-option label="合同列表-EXCEL" value="contract"></el-option>
									<el-option label="发票列表-EXCEL" value="invoice"></el-option>
									<el-option label="银行卡列表-EXCEL" value="bankcard"></el-option>
									<el-option label="付款申请列表-EXCEL" value="paycollection"></el-option>
									<el-option label="平台收票列表-EXCEL" value="platform_invoice"></el-option>
									<!-- <el-option label="退款申请列表-EXCEL" value="refund"></el-option> -->
								</el-select>
							</el-form-item>
							<el-form-item label="状态">
								<el-select v-model="searchForm.status" placeholder="请选择" clearable style="width: 100%;">
									<el-option label="等待中" :value="1"></el-option>
									<el-option label="执行中" :value="2"></el-option>
									<el-option label="错误" :value="3"></el-option>
									<el-option label="正常" :value="4"></el-option>
									<el-option label="已下载" :value="5"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
								<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="k-common-con">
					<div class="k-table-wrapper">
						<!-- <div class="k-table-toolbar" style="margin-top:0;" v-if="$parent.$parent.isAuthAction('admin/news/message/addnotice')">
							<div>
								<el-button type="primary" size="mini" @click="addNewsOpen" v-if="$parent.$parent.isAuthAction('admin/news/message/addnotice')">添加公文</el-button>
							</div>
						</div> -->
						<div class="k-table-con">
							<el-table
									v-loading="loading"
									:data="tableData.data"
									style="width: 100%"
									row-key="id"
									border
									stripe
									ref = "table"
									highlight-current-row
									:height="tableHeight">
								<el-table-column
										fixed
										prop="id"
										label="ID"
										align="center"
										width="50">
								</el-table-column>
								<el-table-column
										prop="task_name"
										label="任务名称"
										min-width="200">
								</el-table-column>
								<el-table-column
										prop="uid_txt"
										label="任务状态"
										min-width="120">
										<template slot-scope="scope">
											<el-tag :size="size" v-if="scope.row.status == '1'" type="info">等待中</el-tag>
											<el-tag :size="size" v-if="scope.row.status == '2'">执行中</el-tag>
											<el-tag :size="size" v-if="scope.row.status == '3'" type="danger">错误</el-tag>
											<el-tag :size="size" v-if="scope.row.status == '4'" type="success">正常</el-tag>
											<el-tag :size="size" v-if="scope.row.status == '5'" type="success">已下载</el-tag>
										</template>
								</el-table-column>
								<el-table-column
										prop="content"
										show-overflow-tooltip
										label="反馈信息"
										min-width="200">
								</el-table-column>
								<el-table-column
										prop="uid_txt"
										label="创建人"
										min-width="100">
								</el-table-column>
								<el-table-column
										prop="create_time"
										label="创建时间"
										width="200">
								</el-table-column>
								<el-table-column
										fixed="right"
										label="操作"
										width="110">
									<template slot-scope="scope">
										<template>
											<el-button @click="downloadExcel(scope.row)" type="text" :disabled="scope.row.status != 4" :size="size">下载</el-button>
											<!-- <el-button @click="handleRelease(scope.row)" type="text" :size="size" :disabled="!(scope.row.is_replace == 2 && scope.row.is_edit == 1)" v-if="$parent.$parent.isAuthAction('admin/news/message/replacenotice')">发布</el-button>
											<el-button @click="handleRelease(scope.row)" type="text" :size="size" :disabled="!(scope.row.is_replace == 1 && scope.row.is_edit == 1)" class="c-danger" v-if="$parent.$parent.isAuthAction('admin/news/message/replacenotice')">取消发布</el-button> -->
										</template>
									</template>
								</el-table-column>
							</el-table>
						<el-pagination
							background
							ref="pagination"
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="tableData.page | number"
							:page-size="tableData.pagesize | number"
							:page-sizes="[15, 30, 50, 100]"
							layout="prev, pager, next, sizes, total"
							:total="tableData.total | number">
						</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</el-tab-pane>
	</el-tabs>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
					loading:false,
					size:'mini',
					activeName:'first',
					searchForm:{
						task_name: '',
						type:'',
						status: ''
					},
					resetSearch: {
							task_name: '',
							type:'',
							status: ''
					},
          tableData: {
              total: 0,
              pagesize: 15,
              page: 1,
              data: []
          },
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 320;
      }
  },
  mounted: function () {
      this.handleSearch(this.searchForm);
  },
  methods: {
		downloadExcel(row) {
			var url = row.download_url;
			if (url) {
				var urls = url.split("/");
				this.$api.get('/admin/customers/export/exportreportexcel',{'file_url':url,'id':row.id}).then(res => {
			   // 将Blob转换为URL以便创建一个可下载的链接
					const url = window.URL.createObjectURL(new Blob([res]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', urls[urls.length - 1]); // 设置下载文件名
					document.body.appendChild(link);
					link.click(); // 触发点击下载
					document.body.removeChild(link); // 下载后移除元素
					window.URL.revokeObjectURL(url); // 释放URL对象
				})
			} else {
				this.$message.error('下载链接不存在,联系管理员');
			}
		},
		handleSizeChange(pages){
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		//列表查询
		handleSearch(params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/fyauth/fyauth/gettasklist',param).then(res => {
			   if (res.code == 0) {
					this.$set(this,'tableData',res.data)
					this.$nextTick(() => {
						 if (this.$refs.table) {
						   this.$refs.table.doLayout();
						 }
					});
			   }else{
				  this.$message.error(res.msg);
			   }
			   this.loading=false
			})
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset() {
		  this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
		  this.doSearch();
		},
		// 排序
		sortChange(e) {
		  var order;
		  var prop = e.prop;
		  if (e.order == 'ascending') {
			  order = 'asc';
		  } else if (e.order == 'descending') {
			  order = 'desc';
		  } 
		  this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
		  this.handleSearch(this.searchForm, val);
		}
  },
}
</script>